import { defineMessages } from 'react-intl';

export default defineMessages({
  provinceFieldLabel: {
    id: 'couponLocationField.provinceFieldLabel',
    defaultMessage: 'Province',
  },
  provinceFieldPlaceholder: {
    id: 'couponLocationField.provinceFieldPlaceholder',
    defaultMessage: 'Select a province',
  },
  cityBlockHeading: {
    id: 'couponLocationField.cityBlockHeading',
    defaultMessage: 'Cities',
  },
  cityInstruction: {
    id: 'couponLocationField.cityInstruction',
    defaultMessage: 'Select one or more cities, or choose Select All.',
  },
  entityProvinces: {
    id: 'couponLocationField.entityProvinces',
    defaultMessage: 'Provinces',
  },
  entitySelectedProvinces: {
    id: 'couponLocationField.entityProvinces',
    defaultMessage: 'Selected Provinces',
  },
  entityCities: {
    id: 'couponLocationField.entityCities',
    defaultMessage: 'Cities',
  },
});
